module.exports = __webpack_public_path__ + "img/IATA北京2026_01.f873c6e2.png";